{
  "NAVIGATION": {
    "TABS": {
      "MANAGE_TEMPLATES": "Templates",
      "OVERVIEW": "Overview",
      "ANALYTICS": "Analytics",
      "DOMAINS": "Domains",
      "IMPORT": "Import",
      "BACKUPS": "Backups",
      "STAGING": "Staging",
      "HELP": "Help",
      "PHP_LOGS": "PHP logs",
      "ACTIVITY_LOGS": "Activity Logs",
      "ADVANCED_TOOLS": "Advanced tools",
      "PHP_MY_ADMIN": "phpMyAdmin",
      "SFTP": "SFTP",
      "EMAILS": "Email history"
    },
    "FOOTER": {
      "POWERED_BY": "Powered by"
    }
  },
  "EMAIL": {
    "NO_EVENTS": "No events found"
  },
  "BUTTONS": {
    "OK": "Ok",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "BACK": "Back",
    "LEARN_MORE": "Learn more"
  },
  "ANALYTICS": {
    "DATE_RANGE_SELECTOR": {
      "TIME_PERIOD": {
        "LAST_7_DAYS": "Last 7 days",
        "LAST_30_DAYS": "Last 30 days",
        "LAST_60_DAYS": "Last 60 days",
        "LAST_90_DAYS": "Last 90 days",
        "LAST_MONTH": "Last month",
        "LAST_3_MONTHS": "Last 3 months",
        "LAST_6_MONTHS": "Last 6 months",
        "LAST_12_MONTHS": "Last 12 months",
        "LAST_16_MONTHS": "Last 16 months",
        "LAST_YEAR": "Last year",
        "CUSTOM": "Custom"
      }
    },
    "SPEED_SCORE_MODAL": {
      "TITLE": {
        "DESKTOP": "Google Desktop PageSpeed Score",
        "MOBILE": "Google Mobile PageSpeed Score"
      },
      "CTA": {
        "IMPROVE_SPEED_DESKTOP": "Improve desktop speed",
        "IMPROVE_SPEED_MOBILE": "Improve mobile speed"
      },
      "SUBTITLES": {
        "DESKTOP": "Your current desktop speed score",
        "MOBILE": "Your current mobile speed score",
        "UPDATED": "Updated",
        "REFRESHED": "Updated now",
        "DAYS_AGO": "days ago",
        "PASSED_RULES": "passed rules",
        "OPPORTUNITIES": "opportunities",
        "REFRESH_TOOLTIP": "Pagespeed Scores are measured weekly, click here to see updated scores."
      },
      "CHART": {
        "INSUFFICIENT_DATA_HEADER": "Nothing yet",
        "INSUFFICIENT_DATA_CONTENT": "We'll show this once we have more data",
        "SPEED_SCORE": "SpeedScore",
        "DESKTOP": "Desktop",
        "MOBILE": "Mobile"
      }
    },
    "VITAL_METRICS_MODAL": {
      "TITLE": "Core Web Vitals",
      "SUBTITLE": "Your website's user experience scores",
      "COLUMNS": {
        "DESKTOP": "Desktop",
        "MOBILE": "Mobile"
      },
      "TOOLTIP": {
        "REFRESHED": "Updated now",
        "REFRESH_TOOLTIP": "Core Web Vitals Scores are measured weekly, click here to see updated scores."
      }
    },
    "UPDATE_TOOLTIP": {
      "UPDATED": "Updated",
      "DAYS_AGO": "days ago",
      "HOURS_AGO": "hours ago",
      "MINUTES_AGO": "minutes ago",
      "SECONDS_AGO": "seconds ago"
    },
    "ANALYTICS_PANEL": {
      "TITLE": "Analytics",
      "CONNECT_GA_VIEW_CTA": "Connect Google Analytics",
      "CREATE_GA_VIEW_CTA": "Create an account",
      "BROKEN_GA_VIEW_CTA": "Your Google Analytics connection has been broken.",
      "RECONNECT_GA_VIEW_CTA": "Reconnect now",
      "CTA_FOR_PERSONAL_ANALYTICS_ACCOUNT": "Have your own Google Analytics account?",
      "DATA_COLLECTION_RUNNING": "Currently collecting data.  Please check back in a few minutes",
      "GATHER_SITE_INSIGHT": "Gather insights about your site visitors",
      "BUTTONS": {
        "START_DATE": "From",
        "END_DATE": "To",
        "APPLY": "Apply",
        "VIEW_MORE": "View more"
      },
      "LABELS": {
        "TOTAL_VISITORS": "Total visitors",
        "PAGE_VIEWS": "Page views",
        "PAGES_SESSION": "Pages per session",
        "BOUNCE_RATE": "Bounce Rate",
        "ENGAGED_SESSIONS": "Engaged Sessions",
        "AVERAGE_TIME_ON_WEBSITE": "Average time on website",
        "PERCENT_NEW_VISITS": "% of new visits",
        "TOTAL_VISITS": {
          "TITLE": "Total visits",
          "LABELS": {
            "TOTAL_VISITS": "Total visits",
            "NEW_VISITS": "New visits",
            "RETURNING_VISITS": "Returning visits"
          }
        },
        "TRAFFIC_SOURCE": "Traffic source",
        "TOP_REFERRAL_SOURCES": "Top referral sources"
      },
      "GA_DISABLED": "Google Analytics Integration disabled",
      "GA_DISABLED_DESC": "The contents of this page are dependent on Google Analytics running on your website. Currently, Google Analytics has been disabled. Enable Google Analytics on the Advanced Tools page to activate these controls once again.",
      "GA_DISABLED_EDIT": "Edit Settings"
    },
    "METRICS": {
      "TOTAL_VISITORS": {
        "TITLE": "Users",
        "SUBTITLE": "The number of unique visitors your website has received"
      },
      "PAGE_VIEWS": {
        "TITLE": "Page views",
        "SUBTITLE": "The number of times a user has viewed a page on your website"
      },
      "PAGES_PER_SESSION": {
        "TITLE": "Pages per session",
        "SUBTITLE": "The average number of pages viewed in a single session"
      },
      "BOUNCE_RATE": {
        "TITLE": "Bounce rate",
        "SUBTITLE": "The percentage of users who left your website after viewing only one page"
      },
      "ENGAGED_SESSIONS": {
        "TITLE": "Engaged Sessions",
        "SUBTITLE": "The number of sessions that lasted longer than 10 seconds, or had a conversion event, or had 2 or more screen views."
      },
      "AVERAGE_TIME_ON_WEBSITE": {
        "TITLE": "Average time on website",
        "SUBTITLE": "The average length of time a user spends on your website"
      },
      "TOTAL_VISITS": {
        "TITLE": "Sessions",
        "SUBTITLE": "The number of times your site has been visited"
      },
      "TRAFFIC_SOURCES": {
        "TITLE": "Traffic sources",
        "COLUMN_TITLE": " Traffic"
      },
      "TOP_REFERRAL_SOURCES": {
        "TITLE": "Top referral sources",
        "COLUMN_TITLE": " Traffic"
      },
      "GOALS": {
        "TITLE": "Goals",
        "HEADING_COLUMN_TITLE": "Goal name",
        "COLUMN_TITLE": "Completions"
      }
    },
    "GA4METRICS": {
      "ACTIVE_USERS": {
        "TITLE": "Active Users",
        "SUBTITLE": "The number of distinct users who visited your site or app."
      },
      "SESSIONS": {
        "TITLE": "Sessions",
        "SUBTITLE": "The number of sessions that began on your site or app (event triggered: session_start)."
      },
      "PAGE_VIEWS": {
        "TITLE": "Page Views",
        "SUBTITLE": "The number of app screens or web pages your users viewed."
      },
      "PAGE_VIEWS_PER_SESSION": {
        "TITLE": "Page/Views Session ",
        "SUBTITLE": "The number of app screens or web pages your users viewed per session."
      },
      "NEW_USERS": {
        "TITLE": "New Users",
        "SUBTITLE": "The number of users who interacted with your site for the first time"
      },
      "AVERAGE_SESSION": {
        "TITLE": "Average Session Duration",
        "SUBTITLE": "The average duration (in seconds) of users' sessions."
      },
      "BOUNCE_RATE": {
        "TITLE": "Bounce rate",
        "SUBTITLE": "The percentage of users who left your website after viewing only one page"
      },
      "ENGAGED_SESSIONS": {
        "TITLE": "Engaged Sessions",
        "SUBTITLE": "The number of sessions that lasted longer than 10 seconds, or had a conversion event, or had 2 or more screen views."
      },
      "TRAFFIC_SOURCES": {
        "TITLE": "Traffic sources",
        "COLUMN_TITLE": "Traffic"
      },
      "TOP_REFERRAL_SOURCES": {
        "TITLE": "Top referral sources",
        "COLUMN_TITLE": "Traffic"
      },
      "GOALS": {
        "TITLE": "Goals",
        "HEADING_COLUMN_TITLE": "Goal name",
        "COLUMN_TITLE": "Completions"
      }
    },
    "ERRORS": {
      "GRAPHS_ERROR": "Error rendering graphs",
      "ANALYTICS_DATA_ERROR": "There was an issue trying to load the analytics data. Please try again."
    },
    "NO_DATA": "No data to display",
    "FAILED_GET_DATA": "Failed to get data"
  },
  "ALERTS": {
    "WEBSITE_PLUS_ALERT": {
      "TITLE": "Website Plus",
      "CONTENT": "Hey Partner &#128075 We are adding new features such as more templates, managed plugin updates, site uptime reporting, and dashboard customization. Click here to join the Beta program.",
      "CTA_BUTTON_TEXT": "Sign up",
      "POPUP_CONTENT": "Thank you for expressing your interest! We will be in touch.",
      "POPUP_ACTION": "Dismiss"
    },
    "GENERAL": {
      "DISMISS": "Dismiss"
    }
  },
  "ONLINE_STORE_SETUP": {
    "GET_STARTED": "Get started selling online!",
    "SETUP_STORE_CARD": {
      "LEARN_MORE": "Want to learn more? Read about ",
      "WC_ACTIVE": {
        "CARD_TITLE": "Set up store",
        "TITLE": "Set up your online store",
        "INFO": "An online store helps to grow your customer base and make shopping easier for your customers.",
        "LINK_1_TEXT": "Create your store",
        "LINK_2_TEXT": "Set up payment processing",
        "LINK_3_TEXT": "Set up order fulfillment",
        "LINK_4_TEXT": "Add products",
        "CTA_BUTTON_TEXT": "Edit store",
        "COURSE_TEXT": "Setting up your WooCommerce store"
      },
      "WC_INACTIVE": {
        "CARD_TITLE": "Set up store",
        "TITLE": "Set up your online store",
        "INFO": "Add an online store to your website easily using <a target=\"_blank\" href=\"https://www.youtube.com/watch?v=1KahlicghaE\">WooCommerce</a>",
        "CTA_BUTTON_TEXT": "Install and activate WooCommerce",
        "COURSE_TEXT": "Setting up your WooCommerce store"
      },
      "DIVI_ACTIVE": {
        "CARD_TITLE": "Customize your site",
        "TITLE": "Customize your site design",
        "INFO": "Help your customers with a recognizable site design that's truly yours.",
        "LINK_1_TEXT": "Customize your homepage",
        "LINK_2_TEXT": "Add your logo",
        "LINK_3_TEXT": "Add your theme colors",
        "LINK_4_TEXT": "Add pages",
        "CTA_BUTTON_TEXT": "Edit site design",
        "COURSE_TEXT": "Editing your site design"
      },
      "CONNECT_ANALYTICS": {
        "CARD_TITLE": "Connect analytics",
        "TITLE": "Monitor traffic and sales",
        "INFO": "Track visitors to your website and get valuable insights about your online sales.",
        "LINK_1_TEXT": "Connect Google Analytics",
        "CTA_BUTTON_TEXT": "View analytics",
        "COURSE_TEXT": "Tracking your stores analytics"
      }
    }
  },
  "CDN_CARD": {
    "TITLE": "Content delivery network",
    "SUBTITLE": "Deliver your static resources, like images, stylesheets, and JavaScript using Google's CDN.",
    "TOGGLE_LABEL": "CDN",
    "CDN_ON": "on",
    "CDN_OFF": "off"
  },
  "ADVANCED_PAGE": {
    "ADVANCED_LOGIN_CARD": {
      "TITLE": "Hide advanced login",
      "DESCRIPTION": "By default access via wp-login.php is hidden to increase security. Turn this feature off to allow access to your site via wp-login.php.",
      "TOGGLE_LABEL": "Hide wp-login.php page",
      "HIDE_WP_LOGIN_ON": "on",
      "HIDE_WP_LOGIN_OFF": "off"
    },
    "SFTP_CARD": {
      "TITLE": "SFTP",
      "DESCRIPTION": "Access your files using a safe and encrypted file transfer. Manage your SFTP keys here.",
      "LINK_TEXT": "SFTP access"
    },
    "PHP_ADMIN_CARD": {
      "TITLE": "phpMyAdmin",
      "DESCRIPTION": "Access your phpMyAdmin dashboard to work directly with your website's database.",
      "LINK_TEXT": "phpMyAdmin"
    },
    "PHP_LOGS": {
      "TITLE": "PHP logs",
      "DESCRIPTION": "Access previous copies of your website's PHP logs for live and staging environments.",
      "LINK_TEXT": "PHP logs"
    },
    "ACTIVITY_LOGS": {
      "TITLE": "Activity logs",
      "DESCRIPTION": "Access WordPress Hosting dashboard activity logs done by the user. Currently supported only staging activities.",
      "LINK_TEXT": "Activity logs"
    },
    "ADVANCED_ANALYTICS_CARD": {
      "TITLE": "Google Analytics Integration",
      "DESCRIPTION": "The charts on the Overview and Analytics pages show visitor usage data is powered by Google Analytics. If you would prefer to not include Google Analytics on your site, you can disable it here.",
      "DIALOG_TEXT": "If you disable Google Analytics, the historical data that has already been collected will also be deleted. Are you sure you want to continue?",
      "BUTTONS": {
        "ACCEPT": "Accept",
        "CANCEL": "Cancel"
      }
    }
  },
  "DEBUG_CARD": {
    "STAGING": {
      "TITLE": "Debug staging site",
      "SUBTITLE": "All PHP errors, notices, and warnings will be displayed on the staging site."
    },
    "LIVE": {
      "TITLE": "Debug live site",
      "SUBTITLE": "All PHP errors, notices, and warnings will be displayed on the live site."
    },
    "TOGGLE_ON": "on",
    "TOGGLE_OFF": "off",
    "TOGGLE_LABEL": "WP_DEBUG"
  },
  "BANNER": {
    "PHP_UPGRADE": {
      "TITLE": "PHP Update Required",
      "TEXT": "PHP 7.4 is no longer secure. Upgrade to 8.1, 8.2, or 8.3 now to keep your sites protected and performing at their best.",
      "LEARN_MORE": "Learn more",
      "ACTION": "Update",
      "MULTIPLE_PHP_8": "PHP 8.2 and 8.3 are now available! Upgrade today for the latest security patches, faster performance, and improved WordPress compatibility."
    },
    "GOOGLE_ANALYTICS": {
      "TITLE": "Connection Required",
      "TEXT": "Universal Analytics will stop collecting data on July 1st. Connect Google Analytics 4 to keep getting data.",
      "LEARN_MORE": "Learn more",
      "ACTION": "Connect"
    },
    "CLOUD_ARMOR": {
      "TITLE": "Google Cloud Armor is now available",
      "TEXT": "Websites can now use Google Cloud Armor to provide additional security!",
      "LEARN_MORE": "Learn more"
    },
    "SUPPORT_UPGRADE": {
      "TEXT": "We're upgrading our support system. Starting Monday, March 30th, Live Chat and the Ticketing Portal will be temporarily unavailable.",
      "TEXT_2": "Active tickets will be transitioned to new threads automatically.",
      "LEARN_MORE": "Learn more"
    },
    "OCSP": {
      "TITLE": "There is a known issue with Firefox browsers showing errors for some sites.",
      "LEARN_MORE": "Learn more"
    }
  },
  "PAGES": {
    "OVERVIEW": {
      "MANAGE_SITE_MODAL": {
        "HEADER": "Your page is live at: ",
        "EDIT_MY_SITE": "Edit my site",
        "WORDPRESS_DASHBOARD": "WordPress dashboard",
        "ADMIN_DASHOBOARD": "Access Admin Dashboard",
        "PHPMYADMIN": "phpMyAdmin",
        "SFTP": "SFTP",
        "PHP_VERSION": "PHP version",
        "WORDPRESS_VERSION": "WordPress version",
        "PLUGIN_UPDATES": "Plugin updates",
        "THEME_UPDATES": "Theme updates",
        "UPDATE_LINK_TEXT": "Update",
        "OPEN_CHANGE_PHP_VERSION_DIALOG_BUTTON": "Change",
        "SUBSITE_LIMIT": "Subsite limit"
      },
      "MANAGE_TEMPLATE_CARD": {
        "TITLE": "Template management",
        "NEW": {
          "SUBTITLE": "Publishing this template to make it available during site creation for any new site.",
          "CONFIRMATION_DESCRIPTION": "Are you sure you want to publish this site as a template?",
          "PUBLISH_BUTTON": "Publish as template",
          "SUCCESS_TITLE": "Template published",
          "SUCCESS_SUBTITLE": "This template has been created and is now available during site creation!"
        },
        "EXISTING": {
          "SUBTITLE": "Updating this template will overwrite the existing template with any changes made. You can always revert a template to one of its backups if you want to undo your changes.",
          "CONFIRMATION_DESCRIPTION": "Are you sure you want to update the existing template with these changes?",
          "PUBLISH_BUTTON": "Update template",
          "SUCCESS_TITLE": "Template updated",
          "SUCCESS_SUBTITLE": "This template has been saved with all of your most recent changes!"
        },
        "GENERAL_PUBLISH_ERROR": "Sorry, but something went wrong."
      },
      "FLUSH_CACHE_MODAL": {
        "TITLE": "Cache",
        "SUBTITLE": "Caching improves your site's speed. Flush the cache to view the latest changes.",
        "BUTTONS": {
          "FLUSH_CACHE": "Flush cache",
          "FLUSH": "FLUSH",
          "CANCEL": "CANCEL"
        },
        "CONFIRMATION": {
          "DESCRIPTION": "Are you sure you want to flush the cache?"
        },
        "FORCE_CACHE_LABEL": "Force site cache",
        "FORCE_CACHE_SETTING": {
          "ON": "on",
          "OFF": "off"
        }
      }
    },
    "CREATE": {
      "TITLE": "Set up your WordPress website",
      "SUBTITLE": "You can change this information at any time.",
      "STEPS": {
        "STEP_1": "Choose a domain",
        "STEP_2": "Pick a starting point",
        "STEP_3": "Launch your site"
      },
      "PLACEHOLDER": {
        "SITE": "Site name",
        "BUSINESS": "Business tagline",
        "FREE_DOMAIN": "Your free domain"
      },
      "BUTTONS": {
        "CREATE": "Create",
        "NEXT": "Next",
        "LAUNCH_YOUR_SITE": "Launch your site"
      },
      "CHARACTERS_REMAINING": "Characters remaining.",
      "ERRORS": {
        "DOMAIN_TOO_LONG": "Sorry, {{domain}} is too long.",
        "DOMAIN_INVALID_SUFFIX": "Sorry, your domain {{domain}} cannot end with {{domainSuffix}}.",
        "DOMAIN_IS_INVALID": "Sorry, {{domain}} seems to be invalid.",
        "ALL_FIELDS_ARE_REQUIRED": "Sorry, all these form fields are required."
      }
    },
    "MIGRATE": {
      "HEADER_TITLE": "Welcome to {{productName}}",
      "HEADER_SUBTITLE": "Before upgrading your site, choose you domain prefix",
      "TITLE": "Migrate WordPress website to Multisite",
      "SUBTITLE": "You can change this information at any time.",
      "STEPS": {
        "STEP_1": "Choose a domain",
        "STEP_2": "Launch your site"
      },
      "PLACEHOLDER": {
        "SITE": "Site name",
        "BUSINESS": "Business tagline",
        "FREE_DOMAIN": "Your free domain"
      },
      "BUTTONS": {
        "CREATE": "Create",
        "NEXT": "Next",
        "LAUNCH_YOUR_SITE": "Migrate your site"
      },
      "CHARACTERS_REMAINING": "Characters remaining.",
      "ERRORS": {
        "DOMAIN_TOO_LONG": "Sorry, {{domain}} is too long.",
        "DOMAIN_INVALID_SUFFIX": "Sorry, your domain {{domain}} cannot end with {{domainSuffix}}.",
        "DOMAIN_IS_INVALID": "Sorry, {{domain}} seems to be invalid.",
        "ALL_FIELDS_ARE_REQUIRED": "Sorry, all these form fields are required."
      }
    },
    "MANAGE_TEMPLATES": {
      "TITLE": "Manage templates",
      "CREATE": {
        "NAME": "Template name",
        "DOMAIN": "Template domain"
      }
    },
    "CREATE_NEW_TEMPLATE": {
      "TITLE": "Create your new template",
      "CREATE_BANNER": {
        "TITLE": "Welcome to website templates!",
        "SUBTITLE": "Enter then name of your template and continue to get started."
      },
      "CREATE_TEMPLATE": "Create template"
    },
    "DELETE_TEMPLATE": {
      "CONTENT": "Are you sure you want to delete this template?",
      "ACTION": "Confirm"
    },
    "CREATE_FROM_TEMPLATES": {
      "DUPLICATE_DIALOG": {
        "TITLE": "Define new template name",
        "CONFIRM": "Create template",
        "CANCEL": "Cancel",
        "POPOVER_UNPUBLISHED": "Template must be published",
        "POPOVER_EMPTY_TITLE": "Template name cannot be empty",
        "POPOVER_MAX_TEMPLATES": "Cannot create more templates"
      },
      "CREATE_BANNER": {
        "TITLE": "Name your website",
        "SUBTITLE": "Next, confirm your website's name and free domain"
      },
      "MIGRATION_BANNER": {
        "MESSAGE": "Template migration in progress (July 15). Templates already moved to our new platform are temporarily unavailable for new site creation. Full access returns July 16. Need to create sites today? Email <a href='mailto:support@vendasta.com'>support@vendasta.com</a> about <a href='https://docs.businessapp.io/wordpress-hosting/import/' target='_blank' rel='noopener'>all-in-one migration</a>. <a href='https://vendasta.canny.io/changelog/we-are-upgrading-your-clients-wordpress-hosting-to-deliver-faster-more-secure-we' target='_blank' rel='noopener'>Why we're upgrading</a>"
      },
      "TEMPLATES_BANNER": {
        "TITLE": "Welcome to {{productName}}",
        "SUBTITLE1": "Before we launch your website, choose how you'd like it to look",
        "IMPORT_TITLE": "Already have a WordPress site?",
        "IMPORT_BUTTON_TEXT": "Import it here"
      },
      "IMPORT_DIALOG": {
        "TITLE": "Import your WordPress website",
        "CONTENT": "To import your existing site, we'll need to create a placeholder WordPress website. This may take a few moments.",
        "ACTION": "Continue",
        "CANCEL": "Cancel"
      },
      "TEMPLATES_MANAGE": {
        "TITLE": "Manage your custom templates",
        "SUBTITLE": "Templates allow you to save themes, plugins, and site content for use when creating a new site. Only users in your organization have access to this tab, but the templates you create will be available to anyone making a new site. Create and edit up to {{ maxTemplates }} of your own templates.",
        "ADD_NEW": "Add new",
        "DISTRIBUTED_TEMPLATES": "Distributed Templates",
        "NON_DISTRIBUTED_TEMPLATES": "Non-Distributed Templates"
      },
      "TEMPLATE_SECTIONS": {
        "ECOMMERCE": {
          "TITLE": "Easy e-commerce",
          "ONLINE_STORE_INFO": "Choose one of these templates if you want your website to include an online store",
          "SUBTITLE": "All of these templates come with&#160<a href='https://www.youtube.com/watch?v=1KahlicghaE' target='_blank'>WooCommerce</a>&#160and&#160<a href='https://www.elegantthemes.com/blog/theme-releases/divi-3' target='_blank'>Divi Builder</a>.",
          "SUBTITLE_PLAINTEXT": "All of these templates come with WooCommerce and Divi Builder."
        },
        "STANDARD": {
          "TITLE": "Standard"
        },
        "PARTNER_CREATED": {
          "TITLE": "Recommended",
          "SUBTITLE": "These templates includes distributed templates."
        },
        "NON_DISTRIBUTED": {
          "TITLE": "Non Distributed",
          "SUBTITLE": "Only visible to Partner center admins"
        },
        "MS_CREATED": {
          "TITLE": "Internal Templates",
          "SUBTITLE": "These templates are only visible to Superadmins."
        }
      },
      "TEMPLATE_SELECTION": {
        "DUPLICATE_WAIT_MESSAGE": "Please Wait",
        "DUPLICATE_READY_SOON": "Your site will be ready soon",
        "PAGE_TITLE": "Select a template",
        "PREVIEW": "Preview",
        "USE_TEMPLATE": "Use template",
        "SELECT_TEMPLATE": "Use ",
        "RESET_FROM_TEMPLATE": "Reset from ",
        "EDIT_TEMPLATE": "Edit template",
        "DELETE": "Delete",
        "DUPLICATE_TEMPLATE": "Duplicate",
        "CONFIRM_RESET_TEMPLATE": {
          "TITLE": "Are you sure you want to reset your staging site?",
          "BODY": "This cannot be undone. Changes made on your previous staging site will be lost",
          "CONFIRM": "Confirm"
        },
        "CONFIRMATION": {
          "TITLE": "Use this template?",
          "BODY": "This will copy all themes, plugins, pages, and posts from this template to your new site. You will not be able to select a different template after launching your website.",
          "CONFIRM": "Confirm"
        }
      },
      "BACK": "Back",
      "ERROR": "There was an error submitting the request."
    },
    "DOMAINS": {
      "CUSTOM_DOMAIN": {
        "ENTER_DOMAIN": "Enter a domain that you own",
        "ALSO_ADD": "Also add"
      },
      "TITLE": "Domains",
      "BUTTONS": {
        "CONNECT_DOMAIN": "Connect a domain",
        "CANCEL": "Cancel"
      },
      "TABLE": {
        "HEADERS": {
          "DOMAINS": "Domains",
          "STATUS": "Status",
          "SSL_CERTIFICATE": "SSL certificate"
        }
      },
      "STATUS": {
        "CONNECTED": "connected",
        "DELETING": "deleting",
        "PENDING": "pending",
        "DISCONNECTED": "disconnected"
      },
      "SSL_STATUS": {
        "AAAA": "AAAA Record detected",
        "AAAA_WARNING": "AAAA (IPv6) records prevent SSL certificates from being generated, please remove the AAAA record on this domain to generate an SSL certificate.",
        "SECURE": "Secure",
        "PENDING": "Pending"
      },
      "ACTIONS": {
        "MAKE_PRIMARY": "Make primary",
        "REMOVE": "Remove"
      },
      "INCORRECT_DNS": {
        "RECORD": "Record",
        "RECOMMENDED_VALUE": "Recommended value",
        "CURRENT_VALUE": "Current value",
        "INSTRUCTIONS": "Update your DNS records with your domain registrar to finish connecting. Records can take up to 48 hours to propagate. It may take a few minutes to configure your server after your correct records have propagated.",
        "DISCONNECTED": "Your domain is no longer connected. Please update your DNS records with your domain registrar to finish connecting. Records can take up to 48 hours to propagate.",
        "LEARN_MORE": "Learn more",
        "NOT_FOUND": "Not found"
      },
      "CHIPS": {
        "PRIMARY": "Primary"
      },
      "INSTRUCTIONS_MODAL": {
        "HEADER": "The primary domain is the domain that all your domains will redirect to. Below are the DNS record details you'll need to point your domain to Website  {{ edition }}.",
        "A_RECORD": "A record",
        "CNAME_RECORD": "CNAME record",
        "NAME": "Name",
        "VALUE": "Value",
        "TTL_VALUE": "leave as default",
        "COPY_HOVER": "Copy value to clipboard",
        "COPY_POPUP": "Value copied to clipboard",
        "HOW_TO_CONNECT_DOMAIN": "How to connect a domain"
      },
      "ADD_DOMAIN_MODAL": {
        "TITLE": "Add domain",
        "BUTTONS": {
          "ADD_DOMAIN": "Add domain",
          "CANCEL": "Cancel"
        }
      },
      "DELETE_DOMAIN_MODAL": {
        "TITLE": "Are you sure you want to delete {{ domain }}?",
        "BUTTONS": {
          "DELETE_DOMAIN": "Delete"
        }
      },
      "MAKE_PRIMARY_MODAL": {
        "TITLE": "Set primary domain",
        "DESCRIPTION": "Your other domains redirect to the primary domain. Do you want {{ domain }} to be your primary domain?",
        "BUTTONS": {
          "MAKE_PRIMARY": "make primary"
        }
      }
    },
    "IMPORT": {
      "TITLE": "Import an existing WordPress website",
      "BUTTONS": {
        "SEE_HOW_IT_WORKS": "See how it works"
      },
      "INSTRUCTIONS_MODAL": {
        "STEP_1": "We recommend you upgrade WordPress core, all plugins, and all themes before importing. Older versions of some plugins are incompatible with PHP 7 and might prevent your site from working in WordPress Hosting {{ edition }}.",
        "STEP_2": "Install and activate the <a href=\"https://en-ca.wordpress.org/plugins/all-in-one-wp-migration/\" target=\"_blank\">All-in-One WP Migration</a> plugin on both your new and existing websites",
        "STEP_3": {
          "STEP_3A": "Use All-in-One WP Migration plugin to export your old site. This plugin will export your entire WordPress site (including database, media, plugins, and themes)",
          "STEP_3B": "All-in-One WP Migration > Export > Export To > File > Save File"
        },
        "STEP_4": {
          "STEP_4A": "Use All-in-One WP Migration plugin to import on your new site:",
          "STEP_4B": "All-in-One WP Migration > Import > Import From > File > Select file exported from old site"
        }
      }
    },
    "IMPORT_MULTISITE": {
      "TITLE": "Import an existing WordPress website into WordPress Hosting Premium",
      "BUTTONS": {
        "SEE_HOW_IT_WORKS": "See how it works"
      },
      "INSTRUCTIONS_MODAL_MULTISITE": {
        "STEP_1": "We recommend you upgrade WordPress core, all plugins, and all themes before importing. Older versions of some plugins are incompatible with PHP 7 and might prevent your site from working in WordPress Hosting {{ edition }}.",
        "STEP_2": "Install and activate the <a href=\"https://en-ca.wordpress.org/plugins/all-in-one-wp-migration/\" target=\"_blank\">All-in-One WP Migration</a> plugin and the <a href=\"https://servmask.com/products/multisite-extension/\" target=\"_blank\">All-in-One WP Migration Multisite Extension</a> on both your new and existing websites.",
        "STEP_3": {
          "STEP_3A": "Use the All-in-One WP Migration plugin to export your old site. This plugin will export your entire WordPress multisite network (including database, media, plugins, and themes):",
          "STEP_3B": "All-in-One WP Migration > Export > Export To > File > Save File"
        },
        "STEP_4": "<strong>Important for Multisite:</strong>\n\nWhen exporting, please make sure to include only the main site and up to 5 subsites (6 sites in total).\n\nOur Multisite import currently supports a maximum of 6 sites, including the main site.",
        "STEP_5": {
          "STEP_5A": "Use the All-in-One WP Migration plugin to import on your new multisite:",
          "STEP_5B": "All-in-One WP Migration > Import > Import From > File > Select file exported from old site"
        }
      }
    },
    "BACKUPS": {
      "TITLE": "Backups",
      "BUTTONS": {
        "BACKUP_NOW": "Backup now",
        "BACKUP_FROM_PRODUCTION": "Backup production",
        "BACKUP_FROM_STAGING": "Backup staging",
        "CREATE_BACKUP_FROM": "Create new backup from {{env}}",
        "ENABLE_STAGING": "Enable staging to Use this feature",
        "RESTORE": "Restore",
        "CANCEL": "Cancel"
      },
      "STEPS": {
        "FILE_BACKUP": "File Backup is in progress",
        "DATABASE_BACKUP": "Database Backup is on progress",
        "EXPORTING": "Exporting files to cloud bucket",
        "ETA": "Estimated time remaining for backup: ",
        "WAIT": "Almost done please wait.."
      },
      "TABS": {
        "PRODUCTION": "Production",
        "STAGING": "Staging"
      },
      "TABLE": {
        "HEADERS": {
          "DATE": "Date",
          "DESCRIPTION": "Description",
          "FILES": "Files",
          "DATABASE": "Database",
          "POSTS": "Posts",
          "PAGES": "Pages",
          "PLUGINS": "Plugins",
          "WP_VERSION": "WordPress version",
          "SUBSITES": "Subsite limit"
        }
      },
      "FAILED": {
        "BACKUP_FAILED": "Backup failed"
      },
      "BACKUP_MODAL": {
        "TITLE": "New manual backup",
        "EXPRESS_DESCRIPTION": "Creating a new backup will overwrite your current manual backup. Upgrade to Pro to access all previously created backups.",
        "DESCRIPTION": "Backup Description",
        "BUTTONS": {
          "BACKUP_NOW": "Backup now"
        }
      },
      "PLUGINS_MODAL": {
        "TITLE": "Plugins",
        "TABLE": {
          "PLUGINS": "Plugins",
          "CHANGES": "Changes since last backup"
        },
        "CHIPS": {
          "INSTALLED": "Installed",
          "UPDATED": "Updated",
          "ACTIVATED": "Activated",
          "DEACTIVATED": "Deactivated"
        },
        "BUTTONS": {
          "CLOSE": "Close"
        }
      },
      "RESTORE_MODAL": {
        "TITLE": "Ready to restore",
        "DESCRIPTION": "Are you ready to restore your website from your {{ date }} {{ env }} environment backup? The process will take a few minutes and you will be unable to edit or visit your site during that time.",
        "BUTTONS": {
          "RESTORE_TO_PRODUCTION": "Restore to production",
          "RESTORE_TO_STAGING": "Restore to staging"
        },
        "SUBSITE_WARNING": {
          "TITLE": "Confirm Restore",
          "LINE_1": "Your subscription allows <b>{{ count }} active subsites.</b>",
          "LINE_2": "If the backup you’re restoring has more subsites than your current plan",
          "LINE_3": "All subsites will be restored and only <b>{{count}} subsites</b> will stay active.",
          "LINE_4": "Extra subsites will be set to <b>deactivated</b> state (you can manage them later in Network Admin → Sites).",
          "LINE_5": "Would you like to continue?"
        }
      },
      "PRO_UPGRADE_MESSAGE": {
        "TITLE": "Restore your site from any backup",
        "SUBTITLE": "Access all of WordPress Hosting features, including the ability to restore your production site from any backup.",
        "UPGRADE_BUTTON_TEXT": "Upgrade to Pro"
      },
      "ETA": {
        "SECOND": "second",
        "MINUTE": "minute",
        "HOUR": "hour",
        "SECONDS": "seconds",
        "MINUTES": "minutes",
        "HOURS": "hours"
      }
    },
    "SFTP": {
      "TITLE": "SFTP access - SSH keys",
      "BUTTONS": {
        "ADD_KEY": "Add Key",
        "CANCEL": "Cancel"
      },
      "INSTRUCTIONS_MODAL": {
        "HEADER": "How to use a key",
        "SUBHEADER": "You will need an SFTP client. We recommend using <a href=\"https://filezilla-project.org/\" target=\"_blank\">FileZilla</a>. It is free and available for Mac or PC.",
        "LIST": {
          "HEADER": "How to use FileZilla:",
          "STEP_1": "Open FileZilla > File > Site Manager > New Site",
          "STEP_2": "Enter host as:",
          "STEP_3": "Enter port as:",
          "STEP_4": "Set protocol field to: SFTP - SSH File Transfer Protocol",
          "STEP_5": "Set logon type to: \"Key file\"",
          "STEP_6": "Enter your user:",
          "STEP_7": "Choose your key file",
          "STEP_8": "Click connect"
        }
      },
      "TABLE": {
        "HEADERS": {
          "KEY_NAME": "Key name",
          "CREATED_BY": "Created by",
          "ACTIONS": "Actions"
        },
        "TOOLTIPS": {
          "DELETE": "Delete"
        }
      },
      "ADD_KEY_MODAL": {
        "TITLE": "Add key",
        "DESCRIPTION": "Key name",
        "BUTTONS": {
          "GENERATE": "Generate key"
        }
      },
      "DELETE_KEY_MODAL": {
        "TITLE": "Confirm",
        "DESCRIPTION": "Are you sure you want to delete the key: {{ key }}",
        "MESSAGE": "Deleting the key...",
        "BUTTONS": {
          "OK": "Ok"
        }
      },
      "DOWNLOAD_KEY_MODAL": {
        "TITLE": "Use key",
        "SUBTITLE": "Download or copy the key now. The key will not be available again.",
        "SUBHEADER": "You will need an SFTP client. We recommend using <a href=\"https://filezilla-project.org/\" target=\"_blank\">FileZilla</a>. It is free and available for Mac or PC.",
        "LIST": {
          "HEADER": "How to use FileZilla:",
          "STEP_1": "Open FileZilla > File > Site Manager > New Site",
          "STEP_2": "Enter host as:",
          "STEP_3": "Enter port as:",
          "STEP_4": "Set protocol field to: SFTP - SSH File Transfer Protocol",
          "STEP_5": "Set logon type to: \"Key file\"",
          "STEP_6": "Enter your user:",
          "STEP_7": "Choose your key file",
          "STEP_8": "Click connect"
        },
        "BUTTONS": {
          "COPY_KEY": "Copy key",
          "DOWNLOAD_KEY": "Download key"
        }
      }
    },
    "STAGING": {
      "TITLE": "Staging area",
      "BUTTONS": {
        "CANCEL": "Cancel"
      },
      "CREATING": {
        "TITLE": "We are setting the stage!",
        "DESCRIPTION": "Setting up the staging environment may take a few minutes depending on the size of your site."
      },
      "PUBLISHING": {
        "TITLE": "We are going live!",
        "DESCRIPTION": "Pushing your staging site to production may take a few minutes depending on the size of your site."
      },
      "MANAGE_STAGING_MODAL": {
        "TOOLS": "Edit your staging site using these tools:",
        "DESCRIPTION": "Your staging website is available at: <br/><a class=\"plain-link accent-font\" target=\"_blank\" href=\"https://{{domain}}\">{{domain}}</a>",
        "WORDPRESS_DASHBOARD": "WordPress dashboard",
        "EDIT_MY_SITE": "Edit my site",
        "PHPMYADMIN": "phpMyAdmin",
        "SFTP": "SFTP"
      },
      "CREATE_STAGING_MODAL": {
        "TITLE": "Use the staging environment to test changes and updates",
        "DESCRIPTION": "A staging site gives you a place to test design changes, plugins, themes, and WordPress updates before publishing them to your live site. Once you're happy with how they look, push them to production with the click of a button.",
        "BUTTONS": {
          "CREATE_STAGING": "Enable staging area",
          "CREATE_STAGING_FROM_BACKUP": "Create staging area from a backup"
        }
      },
      "PUSH_PRODUCTION_MODAL": {
        "TITLE": "Push staging to live site",
        "DESCRIPTION": "Happy with the changes made on your staging site? Push them live. Note: this will overwrite your current live site",
        "CONFIRMATION": {
          "TITLE": "Push staging to live site",
          "DESCRIPTION": "Pushing your staging site will overwrite your current live site and erase your staging",
          "FS_DB": {
            "TITLE": "What would you like to move to your live site?",
            "FS": {
              "TITLE": "Replace only the file system",
              "DESCRIPTION": "This will only update changes to your websites file system. Anything in the database, such as ecommerce orders, form submissions, and plugin data will not be overwritten."
            },
            "DB": {
              "TITLE": "Replace the entire site",
              "DESCRIPTION": "This will completely overwrite the existing site, including both the file system and database."
            }
          },
          "PRESERVE": {
            "TITLE": "Would you like to preserve the staging files for further edits?",
            "CHECKBOX": "Preserve the staging files"
          },
          "CONFIRM": {
            "TITLE": "Confirm moving staging to live site",
            "CHECKBOX": "I am ready to push my staging site to the live site"
          }
        },
        "BUTTONS": {
          "PUSH_TO_LIVE_SITE": "Push to live",
          "CONFIRM": "Confirm",
          "MOVE_SITE": "Push to live"
        }
      },
      "RESET_STAGING_MODAL": {
        "TITLE": "Reset staging site",
        "DESCRIPTION": "Make a new copy of your live site. Changes made on your previous staging site will be lost.",
        "CONFIRMATION": {
          "TITLE": "Are you sure you want to reset your staging site?",
          "SUBTITLE": "This cannot be undone. Changes made on your previous staging site will be lost."
        },
        "BUTTONS": {
          "RESET": "Reset staging",
          "CONFIRM": "Reset",
          "RESET_TO_LIVE_SITE": "Reset to live site",
          "RESET_STAGING_FROM_TEMPLATE": "Reset from a template",
          "RESET_STAGING_FROM_BACKUP": "Reset from a backup"
        }
      },
      "STAGING_FROM_BACKUP_MODAL": {
        "TITLE": "Create a stage from backup",
        "BUTTONS": {
          "CREATE": "Create",
          "CANCEL": "Cancel"
        }
      }
    },
    "EMAILS": {
      "TITLE": "Emails",
      "TABLE": {
        "HEADERS": {
          "TIMESTAMP": "Timestamp",
          "SUBJECT": "Subject",
          "TO": "To",
          "FROM": "From"
        },
        "PARTICIPANTS": "Participants",
        "SENT_AFTER": "Sent after",
        "SENT_BEFORE": "Sent before",
        "DATES": "Dates"
      },
      "NO_EMAILS": {
        "TITLE": "No emails found",
        "SUBTITLE": "Emails will appear after they are sent",
        "IMG": "email_empty_state.svg"
      }
    },
    "PHP_LOGS": {
      "TITLE": "PHP logs",
      "REFRESH": "Refresh",
      "TABLE": {
        "HEADERS": {
          "TIMESTAMP": "Timestamp",
          "LOG": "Log"
        },
        "DOWNLOAD_LOG": "Download log",
        "DOWNLOAD_LOG_FAILED": "Failed to download log. Please try again.",
        "ANALYZE_LOG": "Analyze log"
      },
      "TOGGLE_BUTTON": {
        "PRODUCTION": "Production",
        "STAGING": "Staging"
      },
      "NO_LOGS": {
        "TITLE": "No logs found",
        "SUBTITLE": "Logs will appear when they occur.",
        "IMG": "no-logs-en.svg"
      }
    },
    "ACTIVITY_LOGS": {
      "TITLE": "Activity logs",
      "REFRESH": "Refresh",
      "TABLE": {
        "HEADERS": {
          "CREATED": "Created",
          "USER": "User",
          "SERVICE": "Service",
          "ACTIVITY": "Activity",
          "STATUS": "Status",
          "DESCRIPTION": "Description",
          "COMPLETED": "Completed"
        }
      },
      "NO_ACTIVITY_LOGS": {
        "TITLE": "No activity logs found",
        "SUBTITLE": "Activity logs will appear when they occur.",
        "IMG": "no-logs-en.svg"
      }
    },
    "ADVANCED_SETTINGS": {
      "TITLE": "Advanced settings",
      "SETTINGS": {
        "HTTPS_REDIRECT": {
          "NAME": "Redirect to HTTPS",
          "DESCRIPTION": "Forces your website to redirect traffic to its secure URL using our provided SSL certificate"
        }
      }
    },
    "CHANGE_PHP_VERSION": {
      "TITLE": "Change PHP Version?",
      "INFO": "You may need to update version of WordPress before changing to a newer version of PHP.",
      "WARN": "Changing PHP version may result in a brief amount of downtime for your website",
      "NEW_PHP_VERSION": "New PHP version",
      "CANCEL": "Cancel",
      "ACCEPT": "Change",
      "WARNING_GENERIC": "PHP {{php}} requires WordPress {{wp}} or later."
    }
  },
  "APP_FAILURE": {
    "TITLE": "Something's gone wrong, but we're working on it.",
    "SITE_ERROR": "Try accessing this page again in a few minutes.",
    "DEFAULT": "We're terribly sorry, something went wrong."
  },
  "APP_INSUFFICIENT_PERMISSION": {
    "TITLE": "You don't have permission to view this page.",
    "SITE_ERROR": "Sign in as a different user to continue.",
    "SIGN_IN": "Sign in",
    "ACCESS_GRANTED_TITLE": "Access granted.",
    "CONTINUE_TO_SITE": "Continue to {{ host }}"
  },
  "API_ERROR": {
    "DomainConflictException": "Sorry, the following domains are already taken: {{ data.conflictingDomains }}",
    "InvalidDomainException": "Sorry, but {{ data.domain }} doesn't seem to belong to your site.",
    "InvalidValueException": "Sorry, that is not a valid value.",
    "InvalidValueSubDomainException": "Sorry, but your sub-domain seems to be invalid.",
    "InvalidRequestForDomainStateException": "Sorry, but {{ data.domain }} is in a {{ data.state }} state.",
    "InvalidRequestForPrimaryDomainException": "Sorry, but {{ data.domain }} is currently your primary domain.",
    "MaxNumberDomainsException": "Sorry, but you've reached your limit with {{ data.maxNumber }} domains.",
    "PAGESPEED_MAX_QUOTA": "Failed to refresh PageSpeed Scores. Please try again.",
    "ServiceNotFoundException": "Service not available. Please try again later.",
    "SiteLockedException": "Sorry, the site is busy right now. Please try again later.",
    "SiteNotFoundException": "This is embarrassing; we're having trouble finding your site right now.",
    "SiteReservationConflictException": "Sorry, your account already has a site under construction.",
    "TemplateIsAlreadyDeletingException": "Sorry, the template is already deleted.",
    "SuspendedAPIError": "{{ data.message }}",
    "UNKNOWN": "An error occurred. Please try again."
  },
  "UPGRADE_CTA": {
    "GET_PRO_INFO": "Get more out of",
    "PRO_CHIP": "Pro",
    "KEY_SELLING_POINTS": {
      "CUSTOM_DOMAIN": "Connect your custom domain",
      "BACKUPS": "Restore your site to any daily backup",
      "STAGING": "Test changes with a staging environment",
      "EXPERIENCE": "Experience all aspects of managed web hosting"
    },
    "GET_PRO": "Get Pro",
    "IMAGE_TEXT": "Grow your online business with effortless web hosting",
    "UPGRADE_NOW_TEXT": "Upgrade now for only",
    "UPGRADE_NOW_TEXT_NO_PRICE": "Upgrade now",
    "UPGRADE_NOW_STARTING_AT": "Upgrade now starting at",
    "CTA_TEXT": "Upgrade now!",
    "FREQUENCY": {
      "DAILY": "/day",
      "WEEKLY": "/week",
      "MONTHLY": "/month",
      "YEARLY": "/year",
      "ONCE": "One time",
      "OTHER": "Other"
    },
    "ACTIVE_ORDER_PRIMARY": "Hold tight!",
    "ACTIVE_ORDER_SECONDARY": "Your upgrade is on its way."
  }
}
